import React, { Fragment } from 'react';
import PropTypes from 'prop-types'; //
// Global
// --------------------------------------------------

import Fonts from "../../styles/fonts";
import Scaffolding from "../../styles/scaffolding";
var propTypes = {
  noFonts: PropTypes.bool
};
export function GlobalStyles(_ref) {
  var noFonts = _ref.noFonts; // TODO: deprecate the `<Font />` portion of this component in v5

  if (!noFonts) {
    /* eslint-disable-next-line no-console */
    console.warn('Warning: The Spotify fonts (Circular) provided within `GlobalStyles` needs to be referenced directly in your application as we will be retiring it in v5.x (due to an issue with Styled Components). Please set the `noFonts` prop to `true` for this component in your application.');
  }

  return React.createElement(Fragment, null, !noFonts && React.createElement(Fonts, null), React.createElement(Scaffolding, null));
}
GlobalStyles.propTypes = propTypes;
export default GlobalStyles;